/**
 * Ширина, начиная с которой журнал событий и детали не помещаются в две колонки.
 * Должна совпадать с медиазапросом в EventsPage.module.css.
 */
export const EVENTS_STACKED_QUERY = '(max-width: 1180px)'
